export interface SiteModule {
  id: string;
  name: string;
  summary: string;
  webUrl: string;
  mobileUrl: string;
  apkName: string;
}

const DEFAULT_MODULES_API = 'https://zfby.site:8000/api/public/modules';

export function moduleApiUrl(): string {
  const fromEnv = import.meta.env.VITE_MODULES_API;
  const text = typeof fromEnv === 'string' ? fromEnv.trim() : '';
  return text || DEFAULT_MODULES_API;
}

function textOf(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

export function normalizeModule(raw: Partial<SiteModule> | null | undefined): SiteModule {
  return {
    id: textOf(raw?.id),
    name: textOf(raw?.name),
    summary: typeof raw?.summary === 'string' ? raw.summary : '',
    webUrl: textOf(raw?.webUrl),
    mobileUrl: textOf(raw?.mobileUrl),
    apkName: textOf(raw?.apkName),
  };
}

export async function fetchModules(fetchImpl: typeof fetch = fetch): Promise<SiteModule[]> {
  const resp = await fetchImpl(moduleApiUrl());
  if (!resp.ok) {
    throw new Error('load failed');
  }
  const body = (await resp.json()) as { code?: number; data?: unknown };
  if (!body || body.code !== 0 || !Array.isArray(body.data)) {
    throw new Error('load failed');
  }
  return body.data.map((item) => normalizeModule(item as Partial<SiteModule>));
}
